<template>
  <div style="height: 100vh; width: 100%">
    <div style="width: 100%; display: none; height: 0%">
      <img id="imageid" :src="profpic" />
      <canvas id="imgCanvas" />
      <pdf-make
        ref="pdfMake"
        style="width: 100%"
        :content="content"
        :pageSize="'A4'"
        :pageOrientation="'portrait'"
        :styles="styles"
        :defaultStyle="defaultStyle"
        :show="true"
        :info="{ title: title }"
        @change="
          (e) => {
            src = e;
          }
        "
      >
      </pdf-make>
    </div>
    <iframe
      id="content-frame"
      :src="src"
      style="width: 100%; display: inline-block; height: 100%"
      frameborder="0"
    ></iframe>
  </div>
</template>

<script>
import PdfMake from "@/components/PdfMake";
import { docStyles, docDefaultStyle } from "@/data/TemplateSuratKetMedis.js";
import { headerImage } from "@/data/headerImage.js";
import { labelValueFormatter } from "@/data/helper.js";
// import ttf from 'url-loader!@/assets/微软雅黑.ttf'
//console.log(ttf)
export default {
  name: "DocSuratKetMedis",
  components: {
    PdfMake,
  },
  data() {
    return {
      title: "Surat Keterangan Medis",
      src: "",
      content: [],
      styles: docStyles,
      defaultStyle: docDefaultStyle,
      ralan: {},
      profpic: "https://103.27.207.58/backend/public/images/icon_customer.png",
    };
  },
  methods: {
    executeDocument: function() {
      document.getElementById("content-frame").contentWindow.window.print();
    },
    toDataUrl: function(url, callback) {
      var xhr = new XMLHttpRequest();
      xhr.onload = function() {
        var reader = new FileReader();
        reader.onloadend = function() {
          callback(reader.result);
        };
        reader.readAsDataURL(xhr.response);
      };
      xhr.open("GET", url);
      xhr.responseType = "blob";
      xhr.send();
    },
  },
  beforeRouteEnter: function(to, from, next) {
    next((vm) => {
      vm.fromUrl = ["", "/"].indexOf(from.path) > -1 ? "" : from.fullPath;
      ////console.log(vm.fromUrl);
    });
  },
  mounted: async function() {
    this.ralan = JSON.parse(
      this.CryptoJS.AES.decrypt(
        this.$route.params.slug.replace(/fRWdSl45h/g, "/"),
        this.$store.state.simrsSecretPassphrase
      ).toString(this.CryptoJS.enc.Utf8)
    );
    // alert(JSON.stringify(this.ralan));
    // this.content = docContent;
    var draft = {
      title: "SURAT KETERANGAN MEDIS",
      subtitle: "No. : _________________/20__",
      arr1: [
        { label: "Nama Pasien", value: this.ralan.pasien.nama },
        { label: "No. RM", value: this.ralan.pasien.no_rm },
        { label: "Umur", value: this.ralan.pasien.formatted_umur },
        { label: "Jenis Kelamin", value: this.ralan.pasien.jen_kelamin },
      ],
      arr2: [
        { label: "Hari/Tanggal ", value: this.ralan.formatted_tgl_periksa },
        { label: "Pukul", value: this.ralan.formatted_jam_periksa },
        { label: "Dokter Pemeriksa", value: this.ralan.dokter.nama },
      ],
      p1: `Berdasarkan hasil pemeriksaan didapatkan`,
      arr3: [
        { label: "Keluhan Utama", value: "" },
        { label: "Pemeriksaan Fisik", value: "" },
        { label: "Pemeriksaan Penunjang", value: "" },
        {
          label: "Diagnosa",
          value: `Dx Utama:
        ${
          this.ralan.rln_periksa_dok ? this.ralan.rln_periksa_dok.dx_utama : "-"
        }

        Dx Sekunder:
        ${
          this.ralan.rln_periksa_dok
            ? this.ralan.rln_periksa_dok.dx_sekunder
            : "-"
        }

        Klasifikasi Medis:
        ${
          this.ralan.rln_periksa_dok
            ? this.ralan.rln_periksa_dok.rln_periksa_dok_penyakit
                .map((item) => {
                  return (
                    item.penyakit.tipe +
                    ` ` +
                    item.penyakit.kode +
                    ` - ` +
                    item.penyakit.desc_short
                  );
                })
                .join(", ")
            : "-"
        }`,
        },
        { label: "Terapi yang diberikan", value: "" },
        { label: "Anjuran", value: "" },
      ],
      p2: "Demikian keterangan medis ini dibuat untuk digunakan seperlunya.",
    };
    var sign = `Pekanbaru, ________________________

  Dokter pemeriksa




  ( ${this.ralan.dokter.nama} )`;
    let arr1 = labelValueFormatter(draft.arr1, 90);
    let arr2 = labelValueFormatter(draft.arr2, 100);
    let arr3 = labelValueFormatter(draft.arr3);
    this.content = [
      {
        image: headerImage,
        width: 529,
      },
      {
        text: draft.title,
        style: "title",
      },
      {
        text: "",
        style: "subtitle",
      },
      {
        columns: [[...arr1], [...arr2]],
      },
      {
        style: "paragraph",
        text: draft.p1,
      },
      ...arr3,
      {
        style: "paragraph",
        text: draft.p2,
      },
      {
        text: "",
        style: "gap",
      },
      {
        columns: [
          { text: "" },
          {
            style: "sign",
            text: sign,
          },
        ],
      },
    ];
  },
};
</script>
